import { Check } from "lucide-react";

const plans = [
  {
    name: "Standard",
    priceMain: "0",
    priceUnit: "USD",
    priceNote: "Acceso gratuito",
    description:
      "Accede a algunas sesiones selectas sin costo alguno. Solo tienes que registrarte.",
    features: [
      "Sesiones selectas sin costo",
      "Registro gratuito",
      "Acceso comunidad básica",
    ],
    cta: "Registrarme gratis",
    highlight: false,
  },
  {
    name: "Premium",
    priceMain: "10",
    priceUnit: "USD / mes",
    priceNote: "ó 90 USD anual",
    description: "Accede a los programas fundamentales.",
    features: [
      "Programa Sirena",
      "Programa A.B.C.",
      "Programa P.I.A.",
      "Programa A.M.P.",
      "1 sesión en vivo al mes",
    ],
    cta: "Elegir Premium",
    highlight: false,
  },
  {
    name: "VIP",
    priceMain: "18",
    priceUnit: "USD / mes",
    priceNote: "ó 160 USD anual",
    description: "Todo lo de Premium más los programas avanzados.",
    features: [
      "Todo lo incluido en Premium",
      "Programa O.L.A.",
      "Programa Physiognosis",
      "Programa Imperium",
      "Programa Hermeneia",
      "2 sesiones en vivo al mes",
    ],
    cta: "Elegir VIP",
    highlight: true,
  },
];

export default function Memberships() {
  return (
    <section
      id="mentores"
      data-testid="memberships-section"
      className="relative py-20 lg:py-28 bg-[#030303] border-t border-[#B49A6C]/10 overflow-hidden"
    >
      <div className="absolute inset-0 pattern-rule opacity-40" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-3xl mb-20">
          <p className="text-[10px] uppercase tracking-[0.45em] text-[#B49A6C] mb-10 flex items-center gap-4">
            <span className="h-px w-12 bg-[#B49A6C]/50" />
            III — Membresías
          </p>
          <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Elige tu nivel
            <span className="block italic text-metal mt-2">de acceso.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#B49A6C]/15">
          {plans.map((p, i) => (
            <article
              key={p.name}
              data-testid={`plan-${p.name.toLowerCase()}`}
              className={`relative flex flex-col bg-[#0A0A0B] p-10 lg:p-12 transition-colors duration-700 ${
                p.highlight ? "lg:scale-[1.015]" : ""
              }`}
              style={
                p.highlight
                  ? {
                      background:
                        "linear-gradient(180deg, #131311 0%, #0A0A0B 100%)",
                    }
                  : undefined
              }
            >
              {p.highlight && (
                <span
                  className="absolute top-6 right-6 text-[9px] uppercase tracking-[0.35em] px-3 py-1.5 border border-[#B49A6C]/50"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(180,154,108,0.18) 0%, rgba(180,154,108,0.05) 100%)",
                    color: "#D9CDA8",
                  }}
                >
                  Más popular
                </span>
              )}

              <div>
                <p className="text-[10px] uppercase tracking-[0.4em] text-[#B49A6C] mb-6">
                  {p.name}
                </p>
                <div className="flex items-baseline gap-3 mb-3">
                  <span className="font-display font-light text-6xl lg:text-7xl text-metal leading-none">
                    {p.priceMain}
                  </span>
                  <span className="text-[10px] uppercase tracking-[0.35em] text-[#807C70]">
                    {p.priceUnit}
                  </span>
                </div>
                <p className="text-[10px] uppercase tracking-[0.3em] text-[#807C70] mb-8">
                  {p.priceNote}
                </p>
                <p className="text-[#A89F8E] text-sm leading-relaxed mb-8 font-light">
                  {p.description}
                </p>

                <div className="divider-metal mb-8" />

                <ul className="space-y-3.5 mb-10">
                  {p.features.map((f, idx) => (
                    <li
                      key={idx}
                      className="flex items-start gap-3 text-sm text-[#E8E5DC] font-light leading-snug"
                    >
                      <Check
                        size={14}
                        className="text-[#B49A6C] mt-0.5 shrink-0"
                      />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <a
                href="https://www.skool.com/subconscious-lab-4167/about"
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`plan-cta-${p.name.toLowerCase()}`}
                className="group/btn relative mt-auto inline-flex items-center justify-center text-[10px] uppercase tracking-[0.4em] px-8 py-5 overflow-hidden border border-[#B49A6C]/30 hover:border-[#C9C2B0]/70 transition-all duration-700"
                style={{
                  background:
                    "linear-gradient(180deg, #1F1B14 0%, #0C0A07 55%, #000000 100%)",
                  boxShadow:
                    "inset 0 1px 0 rgba(217,205,168,0.10), inset 0 -1px 0 rgba(0,0,0,0.6), 0 0 28px rgba(0,0,0,0.5)",
                }}
              >
                <span
                  aria-hidden
                  className="absolute inset-0 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-700"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(217,205,168,0.10) 0%, rgba(180,154,108,0.04) 50%, transparent 100%)",
                  }}
                />
                <span
                  className="relative"
                  style={{
                    background:
                      "linear-gradient(180deg, #F0E6CC 0%, #C9B584 45%, #6E5B36 100%)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                  }}
                >
                  {p.cta}
                </span>
              </a>
            </article>
          ))}
        </div>

        <p className="mt-12 text-center text-[10px] uppercase tracking-[0.35em] text-[#807C70]">
          Sin permanencia · Cancela cuando quieras
        </p>
      </div>
    </section>
  );
}
